export default "__VITE_ASSET__TRpaeUZi__"